import { EventosService } from './../../../core/services/eventos.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FeriaService } from 'src/app/core/services/feria.service';
import { MarketplaceService } from 'src/app/core/services/marketplace.service';
import { UsuarioService } from 'src/app/core/services/usuario.service';
import { UtilsService } from 'src/app/core/services/utils.service';


import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-statistics',
  templateUrl: './statistics.component.html',
  styleUrls: ['./statistics.component.scss'],
})
export class StatisticsComponent implements OnInit {
  public usuario = null;
  public nombre_event = "";
  public tipo_event = "";
  public fecha_creacion = "";
  public list_users = [];


  constructor(
    private router: Router,
    private svUsuario: UsuarioService,
   /*  
    
    private svUtils: UtilsService,
    private svMarketplaces: MarketplaceService,
    private svFerias: FeriaService,
    private svEvents: EventosService,

    private dialog: MatDialog */
  ) {}

  ngOnInit(): void {
    if(localStorage.getItem("ev_d")){
        let data = JSON.parse(window.atob(localStorage.getItem("ev_d")))
        this.nombre_event = data.nombre_feria || data.nombre_marketplace || data.nombre_yinkana || "Sin nombre" //data.nombre_feria?data.nombre_feria:(data.nombre_marketplace?data.nombre_marketplace:"")
        this.tipo_event = data.tipo_feria?data.tipo_feria:(data.id_marketplace?"marketplace":"yincana AR")
        this.fecha_creacion = data.fecha_de_registro_marketplace || data.fecha_de_registro_feria || data.fecha_de_registro_yinkana || "N/A"

        this.svUsuario.getVisitantes(data.id_feria?data.id_feria:data.id_marketplace).subscribe((resp) => {
          
          //console.log(resp)
          if (resp['status'] === 'success') {
            this.list_users = resp.body.data
          }
        });



    }else{
        this.router.navigate(['auth/home']);
    }
    //console.log(JSON.parse(window.atob(localStorage.getItem("ev_d"))))
  }

 
  truncateText(texto) {
    return texto.substr(0, 30) + '...';
  }

  
}
